import React from 'react'

export const RecipeListItem = ({ slug, title }) => (
  <li>
    <a href={slug}>{title}</a>
  </li>
)
